<div class="p-6">
  <h2 class="text-xl font-semibold mb-4">{{ data.title }}</h2>
  @if (data.messageHtml) {
    <p class="mb-6 text-base text-agentium_gray-text" [innerHTML]="data.messageHtml"></p>
  } @else {
    <p class="mb-6 text-base text-agentium_gray-text">{{ data.message }}</p>
  }
  <div class="flex justify-end space-x-4">
    <button class="px-6 py-2 bg-gray-200 text-agentium_gray-text text-base rounded-full hover:bg-gray-300 transition-colors" (click)="onCancel()">
      {{ data.cancelButtonText }}
    </button>
    <button class="px-6 py-2 bg-momentum-deep_purple text-white text-base rounded-full hover:bg-momentum-royal_purple transition-colors" (click)="onConfirm()">
      {{ data.confirmButtonText }}
    </button>
  </div>
</div>
